const requestQuote = {
  hero: {
    title: "Запишете се за безплатна консултация",
    description: "Попълнете формата и ще се свържем с вас възможно най-скоро.",
  },
  form: {
    title: "Форма за запитване",
  },
  call: {
    prefix: "Предпочитате да ни се обадите?",
  },
};

export default requestQuote;

